import {Browser} from "./Browser";

export class Display
{
    // Measures and stores various Display parameters
    static analyze()
    {
        // pixel density
        Display.dpi = window.devicePixelRatio ? window.devicePixelRatio : 1;

        // limit maximum dpi to 3
        if(Display.dpi > 3)
        {
            Display.dpi = 3;
        }

        // Display size
        Display.x = (Browser.mobile === true) ? window.innerWidth : document.body.clientWidth;
        Display.y = window.innerHeight;
        Display.ar = Display.x / Display.y;

        // device type
        if(window.matchMedia('(max-width: 650px)').matches)
        {
            Display.device = 'smartphone';
        }
        else if(window.matchMedia('(max-width: 800px)').matches)
        {
            Display.device = 'tablet';
        }
        else
        {
            Display.device = 'desktop';
        }

        // device orientation
        Display.orientation = window.matchMedia('(orientation:portrait)').matches ? 'portrait' : 'landscape';
    }
}